"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var zipcode_1 = require("../../zipcode");
var countryValidators = {};
var zipCodeValidator = function (country) {
    if (typeof country !== 'string' || !country) {
        return function () { return false; };
    }
    var validator = countryValidators[country];
    if (!validator) {
        validator = function (value) {
            if (typeof value !== 'string')
                return false;
            return (0, zipcode_1.isZipCodeValid)(country, value);
        };
        countryValidators[country] = validator;
    }
    return validator;
};
exports.default = zipCodeValidator;
